import { styled } from "@mui/material";

export const CompanyStepRoot = styled("div")`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    max-width: 720px;
    gap: 48px;
    margin: auto;
    text-align: center;
    position: relative;

    & form {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    & footer {
        display: flex;
        flex-direction: column;
        gap: 24px;
        width: 100%;
        min-height: 84px;
    }

    & .company-name {
        font-weight: 400;
    }

    & button {
        width: fit-content;
        margin: auto;
    }
`;

export default CompanyStepRoot;
